import React from 'react';

export default function ProfileCard(props) {
  return (
    <div className="shadow-2xl rounded-lg p-5.5 flex flex-col bg-white mx-4 max-w-sm w-full shrink-0">
      <div className="flex">
        <img
          className="h-16 w-16 min-w-16 object-cover rounded-full mr-5"
          src={`${props.image}?w=128&h=128`}
          alt=""
          aria-hidden="true"
          loading="lazy"
        />
        <div className="flex flex-col">
          <span className="text-lg font-medium text-[#1c1b24] flex items-center whitespace-nowrap">
            {props.title}
          </span>
          {props.subtitle && (
            <span className="text-sm font-semibold text-gray-500 mb-2">{props.subtitle}</span>
          )}
          <span className="text-base text-gray-600">{props.description}</span>
        </div>
      </div>
    </div>
  );
}
